/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Toast_TitleInputs */

const en_invite_toast_title = /** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign-in is not connected yet`)
};

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const ar_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const he_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const ur_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const es_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const fr_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const de_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const pt_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const hi_invite_toast_title = en_invite_toast_title;

/** @type {(inputs: Invite_Toast_TitleInputs) => LocalizedString} */
const bn_invite_toast_title = en_invite_toast_title;

/**
* | output |
* | --- |
* | "Sign-in is not connected yet" |
*
* @param {Invite_Toast_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_toast_title = /** @type {((inputs?: Invite_Toast_TitleInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Toast_TitleInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_toast_title(inputs)
	if (locale === "he") return he_invite_toast_title(inputs)
	if (locale === "ur") return ur_invite_toast_title(inputs)
	if (locale === "es") return es_invite_toast_title(inputs)
	if (locale === "fr") return fr_invite_toast_title(inputs)
	if (locale === "de") return de_invite_toast_title(inputs)
	if (locale === "pt") return pt_invite_toast_title(inputs)
	if (locale === "hi") return hi_invite_toast_title(inputs)
	if (locale === "bn") return bn_invite_toast_title(inputs)
	return /** @type {LocalizedString} */ ("Sign-in is not connected yet")
});